import { StyleSheet } from 'react-native-web';

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    position: 'fixed',
    bottom: 30,
    right: 20,
    zIndex: 1000,
  },
  chatButton: {
    backgroundColor: '#1e3c72', // Solid ocean blue color
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    borderRadius: 50,
    padding: 15,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.8,
    shadowRadius: 2,
    elevation: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  modalContainer: {
    position: 'fixed',
    bottom: 0,
    right: 20,
    width: '90%',
    maxWidth: 400,
    height: '70%',
    backgroundColor: '#e0f7fa', // Light cyan background to resemble ocean
    borderRadius: 10,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.8,
    shadowRadius: 2,
    elevation: 5,
    zIndex: 1001,
  },
  chatContainer: {
    flex: 1,
    padding: 10,
    height: '100%',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    backgroundColor: '#0077be', // Dark blue header to resemble deep ocean
  },
  headerTitle: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
  },
  listContainer: {
    flexGrow: 1,
    justifyContent: 'flex-end',
    paddingHorizontal: 10,
  },
  messageContainer: {
    padding: 10,
    marginVertical: 5,
    borderRadius: 20,
    maxWidth: '80%',
  },
  userMessageContainer: {
    backgroundColor: "#0077be", // Dark blue for user messages
    alignSelf: "flex-end",
  },
  botMessageContainer: {
    backgroundColor: "#e1e1e1",
    alignSelf: "flex-start",
  },
  messageText: {
    fontSize: 16,
    color: '#000',
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10,
    backgroundColor: '#f1f1f1',
    borderTopColor: '#ddd',
    borderTopWidth: 1,
  },
  input: {
    flex: 1,
    padding: 10,
    backgroundColor: "#fff",
    borderRadius: 25,
    color: "black",
    marginRight: 10,
    paddingLeft: 15,
    borderColor: '#ddd',
    borderWidth: 1,
  },
  micIcon: {
    padding: 10,
    backgroundColor: "#0077be", // Dark blue for microphone icon
    borderRadius: 25,
    height: 50,
    width: 50,
    justifyContent: "center",
    alignItems: "center",
  },
  loading: {
    position: "absolute",
    left: "50%",
    bottom: 10,
    transform: [{ translateX: -25 }],
  },
});

export default styles;
